<div class="modal-content col-md-12">
    <div class="form-group top-margin">
        <label>Provision library</label>
        <label id="provisionlibrary" class="form-control top-padding"> {{provisionUserName}}</label>

        <label for="provisionname">Provision name</label>
        <input id="provisionname" class="form-control" autocomplete="off" type="text" maxlength="25" [(ngModel)]="provisionName"
            (ngModelChange)="checkIfExisting()">
        <div class="top-margin">
            <conversion-alert *ngIf="alreadyExists" [type]="'alert-warning'" [message]="'A provision with this name already exists. Saving will override it'"></conversion-alert>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button class="pull-right btn btn-primary btn-sm" type="submit" (click)="this.activeModal.close(provisionName)">Save</button>
                <button class="pull-right btn btn-default btn-sm" (click)="activeModal.close('close')">Cancel</button>
            </div>
        </div>
    </div>
</div>